import React, { createContext, useContext, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { preloadPackageData } from '@/hooks/usePackageData';

interface PackageDataContextType {
  preloadData: () => void;
}

const PackageDataContext = createContext<PackageDataContextType | undefined>(undefined);

export function usePackageDataContext() {
  const context = useContext(PackageDataContext);
  if (!context) {
    throw new Error('usePackageDataContext must be used within a PackageDataProvider');
  }
  return context;
}

interface PackageDataProviderProps {
  children: React.ReactNode;
}

export function PackageDataProvider({ children }: PackageDataProviderProps) {
  const queryClient = useQueryClient();

  const preloadData = () => {
    preloadPackageData(queryClient);
  };

  // Preload data when provider mounts
  useEffect(() => {
    console.log('📦 PackageDataProvider: Starting data preload...');
    preloadData();
  }, []);

  const value: PackageDataContextType = {
    preloadData,
  };

  return (
    <PackageDataContext.Provider value={value}>
      {children}
    </PackageDataContext.Provider>
  );
}